import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const FullPageSkeleton = () => (
  <div
    className="min-h-screen flex items-center justify-center"
    style={{ background: "var(--color-background-primary)" }}
    data-testid="auth-loading"
  >
    <div className="w-[320px] space-y-3">
      <div className="skeleton h-4 w-40" />
      <div className="skeleton h-10 w-full" />
      <div className="skeleton h-10 w-2/3" />
    </div>
  </div>
);

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullPageSkeleton />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
